import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple } from '@fuse';
import { Tab, Tabs } from 'material-ui';

import Tab1Department from './components/Tab1Department';
import Tab2Desingnation from './components/Tab2Desingnation';
import Tab3Greade from './components/Tab3Greade';
import Tab4Employement from './components/Tab4Employement';

const styles = theme => ({
    layoutRoot: {},
    layoutToolbar: {
        padding: 0
    },
    tabsRoot: {
        height: 64
    },
    tabRoot: {
        height: 64
    },
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    }
});

class SystemSetting extends Component {

    state = {
        value: 0
    };

    handleChangeT = (event, value) => {

        this.setState({ value });
        event.preventDefault();
    };


    render() {

        const { value } = this.state;
        const { classes} = this.props;

        return (

            <FusePageSimple
                classes={{
                    root: classes.layoutRoot,
                    toolbar: classes.layoutToolbar
                }}
                // header={

                //     <div className=""><h4>System Setting</h4></div>

                // }

                contentToolbar={
                    < Tabs
                        value={value}
                        onChange={this.handleChangeT}
                        indicatorColor="primary"
                        textColor="primary"
                        scrollable
                        scrollButtons="auto"
                        classes={{
                            root: classes.tabsRoot
                        }
                        }
                    >
                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="Department"
                        />

                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="Designation"
                        />

                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="Employee Grade"
                        />

                        <Tab
                            classes={{
                                root: classes.tabRoot
                            }}
                            label="Employment Type"
                        />

                    </Tabs >
                }
                content={
                    < div className="px-24" >


                        {
                            value === 0 &&
                            (
                                <Tab1Department />

                            )
                        }

                        {
                            value === 1 && (
                                // <Tab2EducationQualification />
                                <Tab2Desingnation />
                            )
                        }

                        {
                            value === 2 && (
                                // <Tab2EducationQualification />
                                <Tab3Greade />
                            )
                        }

                        {
                            value === 3 && (
                                // <Tab2EducationQualification />
                                <Tab4Employement />
                            )
                        }

                    </div >
                }
            />
        )
    };
}



export default withStyles(styles, { withTheme: true })(SystemSetting);


// WEBPACK FOOTER //
// ./src/main/content/hr/systemSetting/SystemSetting.js